import { client } from "@/lib/api_client/client.gen";

let installed = false;

export function setupInterceptors() {
  if (installed) return;
  installed = true;
  client.interceptors.response.use((response) => {
    if (response.status === 401) {
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
    }
    return response;
  });
  // The bundled client returns failures without an HTTP error status (offline,
  // unparseable body) as `{ error }`. Rethrow them as client-fetch 0.13 did.
  client.interceptors.error.use((error, response) => {
    if (!response || response.ok) throw error;
    return error;
  });
}
